export default __webpack_public_path__ + "static/3-85036ef6b8542fd715c77e2637b3b942.webp";